import { render, staticRenderFns } from "./myFileTree.vue?vue&type=template&id=3f8294ce&scoped=true"
import script from "./myFileTree.vue?vue&type=script&lang=js"
export * from "./myFileTree.vue?vue&type=script&lang=js"
import style0 from "./myFileTree.vue?vue&type=style&index=0&id=3f8294ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8294ce",
  null
  
)

export default component.exports